import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import enCommon from './locales/en/common.json';

const defaultLocale = process.env.REACT_APP_I18N_DEFAULT_LOCALE || 'en';
const savedLocale = window.localStorage.getItem('app_locale');

i18n.use(initReactI18next).init({
  resources: {
    en: {
      common: enCommon,
    },
  },
  lng: savedLocale || defaultLocale,
  fallbackLng: 'en',
  supportedLngs: ['en'],
  defaultNS: 'common',
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
